import { useSearchParams } from 'react-router';
import { useModalContext } from './useModalContext';
import { useApiContext } from 'react-easyrocket';
import { useEffect } from 'react';
import { useAuthFlow } from '../modules/authFlow/hooks/useAuthFlow';

export const useTrackLinkAction = () => {
  const [searchParams] = useSearchParams();
  const { openModal } = useModalContext();
  const { isAuthenticated } = useApiContext();
  const { startRegistration } = useAuthFlow();
  const action = searchParams.get('action');
  useEffect(() => {
    if (!isAuthenticated && action === 'signup') {
      startRegistration();
    }
  }, [action, isAuthenticated, openModal]);
};
